module.exports = __webpack_public_path__ + "img/nl_Ecran 1.1706245a.png";